<template>
  <div>
    <el-row :gutter="15">
      <el-col :lg="4" :md="8" :sm="8">
        <el-card>
          <div slot="header">
            待审核客户数
          </div>
          <div class="statistics">
            <div>
              客户：<bean-link keepNode :to="{ name: 'formal_accounts.index', query: { status_eq: 'pending' } }" can="accounts.read">{{ data.formal_accounts_pending_count }}</bean-link>
            </div>
            <div>
              游客：<bean-link keepNode :to="{ name: 'visitor_accounts.index', query: { status_eq: 'pending' } }" can="accounts.read">{{ data.formal_accounts_pending_count }}</bean-link>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="4" :md="8" :sm="8">
        <el-card>
          <div slot="header">
            待审核交易申请
          </div>
          <div class="statistics">
            <bean-link keepNode :to="{ name: 'trade_apply_records.index', query: { state_eq: 'pending' } }">{{ data.trade_apply_records_pending_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="4" :md="8" :sm="8">
        <el-card>
          <div slot="header">
            待确认交易记录数
          </div>
          <div class="statistics">
            <bean-link keepNode :to="{ name: 'trades.index', query: { state_eq: 'pending' } }">{{ data.trades_pending_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="4" :md="8" :sm="8">
        <el-card>
          <div slot="header">
            待审核双录视频数
          </div>
          <div class="statistics">
            <bean-link keepNode :to="{ name: 'video_records.index', query: { status_eq: 'auditing' } }">{{ data.video_records_pending_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="4" :md="8" :sm="8">
        <el-card>
          <div slot="header">
            客户数
          </div>
          <div class="statistics">
            <bean-link keepNode :to="{ name: 'formal_accounts.index' }" can="accounts.read">{{ data.formal_accounts_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
      <el-col :lg="4" :md="8" :sm="8">
        <el-card>
          <div slot="header">
            游客数
          </div>
          <div class="statistics">
            <bean-link keepNode :to="{ name: 'visitor_accounts.index' }" can="accounts.read">{{ data.visitor_accounts_count }}</bean-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-card>
          <div slot="header">
            交易金额趋势折线图
          </div>
          <div>
            <ECharts :options="tradeAmountTrendLineOptions" style="width:100%" />
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" v-if="displayFundRelated">
      <el-col :span="24">
        <el-card>
          <div slot="header">
            基金趋势折线图
          </div>
          <el-form size="mini">
            <el-form-item label="日期筛选">
              <el-date-picker
                v-model="fundsTrendFilter.date_rage"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="fundsTrendDateRangePickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item v-loading="loadingFundValue">
              <el-checkbox-group v-model="fundsTrendFilter.fund_id_in">
                <el-checkbox v-for="item in fundValue" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="handleResetFundsTrendFilter">重置</el-button>
              <el-button v-on:click="handleFilter" type="primary">筛选</el-button>
              <bean-export-button buttonText="导出" url="/dashboard/export_funds_trend" :params="fundsTrendFilterParams" />
            </el-form-item>
          </el-form>
          <ECharts :options="fundsTrendLineOptions" style="width:100%" />
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" v-if="displayFundRelated">
      <bean-table :value="fundValue" :columns="fundColumns" v-loading="loadingFundValue" :height="null" />
    </el-row>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import { abilityService } from 'beans-admin-plugin';
import ECharts from 'vue-echarts';
import { columnsExtend } from '@/admin_entities/fund_detail';
import { getLabel } from '@/custom_models_extend';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

const FUNDS_TREND_FILTER_default = {
  date_rage: [],
  fund_id_in: []
}

@Component({
  components: {
    ECharts
  }
})
export default class ApplicationHome extends Vue {
  data = {
    formal_accounts_pending_count: 0,
    visitor_accounts_pending_count: 0,
    trade_apply_records_pending_count: 0,
    trades_pending_count: 0,
    video_records_pending_count: 0,
    formal_accounts_count: 0,
    visitor_accounts_count: 0,
    allot_trade_amount_trend: [],
    redeem_trade_amount_trend: [],
    achievement_pay_trade_amount_trend: [],
    cash_dividend_trade_amount_trend: []
  }
  loadingFundValue = false
  fundValue = []
  fundsTrend = {
    total_capital_trend: [],
    total_amount_trend: [],
    total_share_trend: []
  }

  fundsTrendFilter = _.cloneDeep(FUNDS_TREND_FILTER_default);

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  get displayFundRelated() {
    return abilityService.can('funds.read')
  }

  get fundColumns() {
    return columnsExtend([
      {
        key: 'name',
        renderCell: (h, { props: { scope: { row } } }) => {
          return <bean-link to={{ name: 'funds.show', params: { id: row.id } }}>{getLabel({ item: row })}</bean-link>
        }
      },
      {
        prop: 'revenue_datum.total_capital',
        label: '资产'
      },
      {
        prop: 'revenue_datum.total_share',
        label: '份额'
      },
      {
        prop: 'latest_fund_value.value',
        label: '净值'
      },
      {
        prop: 'holders_count',
        label: '有效持有人数'
      }
    ])
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/application')
    if (this.displayFundRelated) {
      this.fundsTrend = await this.$request.get('/dashboard/funds_trend')

      this.loadingFundValue = true
      this.fundValue = (await this.$request.get('/funds', { is_index_eq: false, page: 0 }))
      this.loadingFundValue = false
    }
  }

  get tradeAmountTrendLineOptions() {
    const legendData = ['申购', '赎回', '业绩报酬', '现金分红']

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.data.allot_trade_amount_trend)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map([
        this.data.allot_trade_amount_trend,
        this.data.redeem_trade_amount_trend,
        this.data.achievement_pay_trade_amount_trend,
        this.data.cash_dividend_trade_amount_trend,
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }

  get fundsTrendLineOptions() {
    const legendData = ['总资产', '总本金', '总份额']

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.fundsTrend.total_capital_trend)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map([
        this.fundsTrend.total_capital_trend,
        this.fundsTrend.total_amount_trend,
        this.fundsTrend.total_share_trend,
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }

  fundsTrendDateRangePickerOptions() {
    return {
      disabledDate(time) {
        return time.getTime() > Date.now();
      }
    }
  }

  get fundsTrendFilterParams() {
    const dateRange = this.fundsTrendFilter.date_rage || [];
    return {
      ..._.omit(this.fundsTrendFilter, ['date_rage']),
      start_date: dateRange[0],
      end_date: dateRange[1]
    }
  }

  handleResetFundsTrendFilter() {
    this.fundsTrendFilter = _.cloneDeep(FUNDS_TREND_FILTER_default);
    this.handleFilter();
  }

  async handleFilter() {
    this.fundsTrend = await this.$request.get('/dashboard/funds_trend', this.fundsTrendFilterParams)
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-col {
    margin-bottom: 10px;
  }
</style>
